import './kerrys/style';
import FormStructure from './kerrys/form_structure';

export default FormStructure;